export const env = {
  REACT_APP_RECEIVER_EMAIL: process.env.REACT_APP_RECEIVER_EMAIL,
  REACT_APP_SENDER_EMAIL: process.env.REACT_APP_SENDER_EMAIL,
  REACT_APP_PAYPAL_EMAIL: process.env.REACT_APP_PAYPAL_EMAIL
};